<template>
  <div>
    <img v-if="isLoading" src="../../assets/images/loading_img.gif" />
    <div v-else id="order-info-container">
      <h3>{{message}}</h3>
      <h4 v-if="isRequestUnderProcess" id="request-under-process-msg">
        <span id="attention-header">{{ labels.order.attentionHeader[language] }}</span>
        {{labels.order.requestUnderProcessMsg[language]}} {{phoneNumber}}
      </h4>
      <div v-if="isRequestUnderProcess" id="buttons-container">
        <button
          class="action-button"
          id="accept-button"
          @click="executeOrder"
        >{{labels.order.acceptRequest[language]}}</button>
        <button
          class="action-button"
          id="reject-button"
          @click="rejectRequest"
        >{{labels.order.rejectRequest[language]}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import OrderApi from "../../api/order";
export default {
  name: "ChangeOrderStatus",
  components: {
  },
  data() {
    return {
      message: "Please wait. Loading..",
      isLoading: false,
      languageOnlyForPinScreen: 'ENG',
      isRequestUnderProcess: false,
      phoneNumber: '',
      isLoading: false,
      orderId: null,
      restaurantId: null,
      token: null,
      status: null
    };
  },
  computed: {
    language() {
      return this.$store.getters.getLanguage;
    },
  },
  methods: {
    setTitle() {
      try {
        document.title = "Fluter";
      } catch (error) {
        console.log("Could not set title");
      }
    },
    async changeStatusForOrder(status) {
      this.isRequestUnderProcess = false;
      if (!this.orderId || !this.restaurantId || !this.token || !status) {
        this.message = "Missing data to change status for order"
        return;
      }

      this.isLoading = true;
      let result = await OrderApi.changeStatus(this.orderId, this.restaurantId, this.token, status);
      setTimeout(() => {
        OrderApi.sendResponseToUser(this.orderId, this.restaurantId, this.token);
      }, 1000);
      if (result.orderStatus == 'ERROR') {
        this.message = result.message[this.language];
        if (result.errorCode == 'ORDER_NOT_PENDING_STATUS' || result.errorCode == 'ORDER_CANNOT_BE_REJECTED') {
          let extraErrorMessage = status == 'ACCEPTED' ? this.labels.order.cannotAcceptOrder[this.language] : this.labels.order.cannotRejectOrder[this.language];
          this.message = this.message + ". " + extraErrorMessage;
        }
        this.isLoading = false;
        return;
      }


      let order = result.order;
      if (order.status == 'ACCEPTED' && !order.hasBeenExecuted && order.restaurant.delayedResponse) {
        this.phoneNumber = order.phoneNumber;
        this.isRequestUnderProcess = true;
        this.message = this.labels.order.orderUnderProccess[this.language];
        this.isLoading = false;
        return;
      }

      this.message = result.orderStatus == 'ACCEPTED' ? this.labels.order.succesfullyAcceptedOrder[this.language] : this.labels.order.succesfullyRejectedOrder[this.language];
      this.isLoading = false;
    },

    async rejectRequest() {
      await this.changeStatusForOrder('REJECTED');
    },

    async executeOrder() {
      this.isRequestUnderProcess = false;
      if (!this.orderId || !this.restaurantId || !this.token) {
        this.message = "Missing data to change status for order"
        return;
      }
      this.isLoading = true;
      let result = await OrderApi.changeExecution(this.orderId, this.restaurantId, this.token, true);
      if (result.orderStatus == 'ERROR') {
        this.message = result.message[this.language];
        this.isLoading = false;
        return;
      }
      this.message = this.labels.order.succesfullyAcceptedOrder[this.language];
      this.isLoading = false;
    }
  },
  async mounted() {
    this.setTitle();
    this.orderId = this.$route.query.orderId;
    this.restaurantId = this.$route.query.restaurantId;
    this.token = this.$route.query.token;
    this.status = this.$route.query.status;
    await this.changeStatusForOrder(this.status);
  }
}
</script>

<style scoped>
#order-info-container {
  margin-left: 8px;
  margin-top: 8px;
  width: 95%;
  max-width: 500px;
}

#request-under-process-msg {
  color: #007bff;
  margin-bottom: 20px;
}

#buttons-container {
  display: flex;
  flex-direction: row;
  max-width: 450px;
  justify-content: space-between;
}

.action-button {
  color: white;
  padding: 6px 10px 6px 10px;
  border-radius: 10px;
}

#accept-button {
  background-color: #198b4a;
}

#reject-button {
  background-color: #d9534f;
}

#attention-header {
  color: #ff721f;
  font-weight: 700;
  margin-right: 2px;
}
</style>